import { useEffect, useState, useCallback } from 'react';

interface UseOnScreenProps {
  offset?: string;
  onFirstSeen?(): void;
}

function useOnScreen(props: UseOnScreenProps) {
  const { offset = '0px', onFirstSeen = () => {} } = props;
  const [isOnScreen, setOnScreen] = useState(false);
  const [hasBeenSeen, setHasBeenSeen] = useState(false);

  const ref = useCallback(
    node => {
      if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(
          ([entry]) => {
            setOnScreen(entry.isIntersecting);
          },
          {
            rootMargin: offset,
          }
        );

        let currentNode: HTMLElement;
        if (node !== null) {
          observer.observe(node);
          currentNode = node;
        }

        return () => {
          if (currentNode !== null) {
            observer.unobserve(currentNode);
          }
        };
      }
    },
    [offset]
  );

  useEffect(() => {
    if (isOnScreen && !hasBeenSeen) {
      onFirstSeen();
      setHasBeenSeen(true);
    }
  }, [isOnScreen, hasBeenSeen, onFirstSeen]);

  return { ref, isOnScreen };
}

export default useOnScreen;
